import { render, staticRenderFns } from "./FundingKicker.vue?vue&type=template&id=7ef33740"
import script from "./FundingKicker.vue?vue&type=script&lang=js"
export * from "./FundingKicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports